import { Renderer2 } from '@angular/core';

export class RendererInstance {
  static renderer: Renderer2;
}
